module.exports = __webpack_public_path__ + "img/Dantam Makeover 11.4620e020.jpg";